import React, { useEffect, useState } from 'react';

import Dialog from 'components/dialog';
import { toaster } from 'components/toaster/toaster';
import { CustomEventNames, EventTypes, logEvent } from 'state/amplitude';
import { t } from 'state/intl/translations';
import { useNetworkContext } from 'state/network';
import logger from 'utils/logger';

function ErrorNetwork() {
  const { isNetworkConnected, isInternetReachable, isSlow } = useNetworkContext();

  // don't spam both types of network issues if one already showed up
  const [hasBeenNotified, setHasBeenNotified] = useState(false);

  // no network connection
  const [isNoNetworkOpen, setIsNoNetworkOpen] = useState(false);
  useEffect(() => {
    if (!isNetworkConnected && !hasBeenNotified) {
      logger.info({
        message: '[BadNetwork] Showing no network connection dialog',
        isNoNetworkConnectionDialog: true,
        isBadNetwork: true,
      });
      logEvent(CustomEventNames.NETWORK_ERROR, EventTypes.Other);
      setHasBeenNotified(true);
      setIsNoNetworkOpen(true);
    }
  }, [hasBeenNotified, isNetworkConnected, isSlow]);

  // bad network connection
  const [isBadNetworkOpen, setIsBadNetworkOpen] = useState(false);
  useEffect(() => {
    if (!isInternetReachable && !hasBeenNotified) {
      logger.info({
        message: '[BadNetwork] Showing bad internet dialog',
        isBadInternetDialog: true,
        isBadNetwork: true,
      });
      logEvent(CustomEventNames.NETWORK_ERROR, EventTypes.Other);
      setHasBeenNotified(true);
      setIsBadNetworkOpen(true);
    }
  }, [hasBeenNotified, isInternetReachable]);

  useEffect(() => {
    if (isSlow) {
      logger.info({
        message: '[SlowNetwork] Showing Slow Network Toast',
        isSlowNework: true,
      });
      toaster.negative(t('slowNetworkIssue'));
    }
  }, [isSlow]);

  if (isNoNetworkOpen) {
    return (
      <Dialog
        showDialog
        modalAppearanceEventMessage="Network Error"
        testID="error-network-dialog"
        heading={t('lostNetworkConnectivity')}
        body={t('checkNetworkSettings')}
        accessibilityLabel={t('lostNetworkConnectivity')}
        isErrorModal
        showCloseButton
        onDismiss={() => {
          setIsNoNetworkOpen(false);
        }}
      />
    );
  }

  if (isBadNetworkOpen) {
    const heading = t('lostNetworkConnectivity');
    return (
      <Dialog
        showDialog
        modalAppearanceEventMessage={heading}
        testID="error-bad-network-dialog"
        heading={heading}
        body={t('badNetworkDialogBody')}
        accessibilityLabel={heading}
        isErrorModal
        showCloseButton
        onDismiss={() => {
          setIsBadNetworkOpen(false);
        }}
      />
    );
  }

  return null;
}

export default ErrorNetwork;
